export default __webpack_public_path__ + "images/trust_bc8bdd.svg";